var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.295,
    height: 54.295,
    viewBox: "0 0 54.295 54.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f067ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M48.3,42.291A6,6,0,0,0,42.522,46.7H32.935a6.02,6.02,0,0,0-4.19-4.2v-6.06H44.517a9.614,9.614,0,0,0,.726-19.2A8.54,8.54,0,0,0,34.222,9.9a10.187,10.187,0,0,0-20.37.3v.713h-.907a12.766,12.766,0,0,0,0,25.533H25.568v6.06a6.019,6.019,0,0,0-4.19,4.2h-9.6a6,6,0,1,0,0,3.181h9.6a5.991,5.991,0,0,0,11.557,0h9.587A5.995,5.995,0,1,0,48.3,42.291ZM3.372,23.681A9.59,9.59,0,0,1,12.945,14.1h4.084V10.2a7.01,7.01,0,1,1,14.02,0v5.4l2.53-1.865a5.306,5.306,0,0,1,3.17-1.041A5.365,5.365,0,0,1,42.1,18.061a5.494,5.494,0,0,1-.032.581l-.188,1.76h2.633a6.432,6.432,0,0,1,0,12.864H12.945a9.589,9.589,0,0,1-9.572-9.585ZM5.994,51.114a2.821,2.821,0,1,1,2.817-2.821A2.822,2.822,0,0,1,5.994,51.114Zm21.162,0a2.821,2.821,0,1,1,2.817-2.821A2.822,2.822,0,0,1,27.156,51.114Zm21.145,0a2.821,2.821,0,1,1,2.817-2.821A2.822,2.822,0,0,1,48.3,51.114Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices2);
export default __webpack_public_path__ + "static/media/services2.4a5cdbf0d068d9845123713844d86593.svg";
export { ForwardRef as ReactComponent };